import React from 'react';

import { IconProps } from './types';

const LogoutIcon: React.FC<IconProps> = props => {
  const { width = '20', height = '20', fillColor = 'var(--grayscale-content-3)' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <g id="logout">
        <mask
          id="mask0_2771_2093"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={width}
          height={height}
        >
          <rect
            id="Bounding box"
            x="0.5"
            width={width}
            height={height}
            fill="var(--lightgray-base)"
          />
        </mask>
        <g mask="url(#mask0_2771_2093)">
          <path
            id="logout_2"
            d="M10.7167 10.85C10.5944 10.7056 10.5333 10.5416 10.5333 10.358C10.5333 10.1749 10.5944 10.0222 10.7167 9.9L11.95 8.66667H7.16667C6.97778 8.66667 6.81956 8.60267 6.692 8.47467C6.564 8.34711 6.5 8.18889 6.5 8C6.5 7.81111 6.564 7.65267 6.692 7.52467C6.81956 7.39711 6.97778 7.33333 7.16667 7.33333H11.95L10.7167 6.1C10.5833 5.96667 10.5167 5.80844 10.5167 5.62533C10.5167 5.44178 10.5833 5.28333 10.7167 5.15C10.8389 5.01667 10.9918 4.95 11.1753 4.95C11.3584 4.95 11.5111 5.01111 11.6333 5.13333L14.0333 7.53333C14.1 7.6 14.1473 7.67222 14.1753 7.75C14.2029 7.82778 14.2167 7.91111 14.2167 8C14.2167 8.08889 14.2029 8.17222 14.1753 8.25C14.1473 8.32778 14.1 8.4 14.0333 8.46667L11.6333 10.8667C11.4889 11.0111 11.3307 11.0749 11.1587 11.058C10.9862 11.0416 10.8389 10.9722 10.7167 10.85ZM3.83333 14C3.46667 14 3.15267 13.8696 2.89133 13.6087C2.63044 13.3473 2.5 13.0333 2.5 12.6667V3.33333C2.5 2.96667 2.63044 2.65267 2.89133 2.39133C3.15267 2.13044 3.46667 2 3.83333 2H7.83333C8.02222 2 8.18067 2.06378 8.30867 2.19133C8.43622 2.31933 8.5 2.47778 8.5 2.66667C8.5 2.85556 8.43622 3.01378 8.30867 3.14133C8.18067 3.26933 8.02222 3.33333 7.83333 3.33333H3.83333V12.6667H7.83333C8.02222 12.6667 8.18067 12.7307 8.30867 12.8587C8.43622 12.9862 8.5 13.1444 8.5 13.3333C8.5 13.5222 8.43622 13.6804 8.30867 13.808C8.18067 13.936 8.02222 14 7.83333 14H3.83333Z"
            fill={fillColor}
          />
        </g>
      </g>
    </svg>
  );
};
export default LogoutIcon;
